module.exports = __webpack_public_path__ + "static/media/sugar_rush.pragmaticplay.9917e3dc.jpeg";